import React, { Fragment } from 'react'
import { Grid } from '@material-ui/core'

import { required, isMainCity } from 'services/validations'
import { Autocomplete } from 'components'

export const CitiesFieldsBase = ({
  allCities, from, to, routeCities, disabledCities,
  toCityId, fromCityId, isPartner, isLimitedDispatcher
}) => {
  const valitation = isPartner || isLimitedDispatcher 
    ? [required, isMainCity] 
    : required
  const isFromCityDisabled = disabledCities.includes(fromCityId)
  const isFromToDisabled = disabledCities.includes(toCityId)

  return (
    <Fragment>
      <Grid item xs={6}>
        <Autocomplete
          required
          form='book'
          name='from'
          value={from}
          label='Звідки'
          validate={valitation}
          suggestion={routeCities.length ? routeCities : allCities}
          helperText={isFromCityDisabled ? 'Місто заблоковане!' : null}
        />
      </Grid>

      <Grid item xs={6}>
        <Autocomplete
          required
          name='to'
          form='book'
          value={to}
          label='Куди'
          validate={valitation}
          suggestion={routeCities.length ? routeCities : allCities}
          helperText={isFromToDisabled ? 'Місто заблоковане!' : null}
        />
      </Grid>
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/CitiesFields/CitiesFields.js